import brandNamesConstants from '@constants/brandNames.constants'
import SmilezyLogo from '../assets/images/SmilezyLogo.svg'
import imageAppLogo from '../assets/images/Dental Stack Logo.svg'
import dentalStackFavicon from '../assets/icons/DentalStackFavIcon.svg'
import smilezyFavicon from '../assets/icons/SmilezyFavIcon.svg'
import RouteToSmileLogo from '../assets/images/RtsLogo.svg'
import CraftAlignLogo from '../assets/images/CraftAlignLogo.svg'
import CraftAlignFavicon from '../assets/images/CraftAlignFavicon.png'
import RouteToSmileFavicon from '../assets/images/RouteToSmileFavicon.svg'
import SynapseLogo from '../assets/images/SynapseLogo.svg'
import SynapseFavicon from '../assets/images/SynapseFavicon.png'
import ClearCastle from '../assets/images/ClearCastleAlignersLogo.svg'
import ClearCastleFavicon from '../assets/images/ClearCastleAlignersFavIconLogo.png'
import SmileXcelFavicon from '../assets/images/SmileXcelFavicon.png'
import SmileXcelLogo from '../assets/images/SmileXcelLogo.png'
import AiiqLogo from '../assets/images/AIIQ_NEW_LOGO.png'
import AiiqFavicon from '../assets/images/AIIQ_FavIcon.png'
import ConfidentAlignerLogo from '../assets/images/ConfidentAlignerLogo.png'
import ConfidentAlignerFavicon from '../assets/images/ConfidentAlignerFavicon.png'
import {
  getBrandPortalUrl,
  getBrandPrivacyPolicyUrl,
  getBrandTermsAndConditionsUrl,
  normalizeBrandName,
} from './brandUrls'

export default (brandName?: string | null) => {
  const brand = normalizeBrandName(brandName || process.env.REACT_APP_BRAND_NAME)

  const defaultBrandConfig = {
    name: 'Dental Stack',
    logo: imageAppLogo,
    termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.DENTALSTACK),
    privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.DENTALSTACK),
    brand,
    favIcon: dentalStackFavicon,
    inviteLink: getBrandPortalUrl(brandNamesConstants.DENTALSTACK, {includeTrailingSlash: true}),
    formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
    bracesFormId: 'dfe6af14-3abd-447e-9962-d02e8e4d41cf',
  }

  switch (brand) {
    case brandNamesConstants.SMILEZY:
      return {
        name: 'Smilezy',
        brand: brand,
        logo: SmilezyLogo,
        favIcon: smilezyFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.SMILEZY),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.SMILEZY),
        inviteLink: getBrandPortalUrl(brandNamesConstants.SMILEZY, {includeTrailingSlash: true}),
        formId: '74173137-a96b-473e-8422-af896ed252a1',
      }

    case brandNamesConstants.ROUTETOSMILE:
      return {
        name: 'Route to smile',
        brand: brand,
        logo: RouteToSmileLogo,
        favIcon: RouteToSmileFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.ROUTETOSMILE),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.ROUTETOSMILE),
        inviteLink: getBrandPortalUrl(brandNamesConstants.ROUTETOSMILE, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }

    case brandNamesConstants.CRAFTALIGN:
      return {
        name: 'Craft align',
        brand: brand,
        logo: CraftAlignLogo,
        favIcon: CraftAlignFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.CRAFTALIGN),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.CRAFTALIGN),
        inviteLink: getBrandPortalUrl(brandNamesConstants.CRAFTALIGN, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }
    case brandNamesConstants.SYNAPSE:
      return {
        name: 'OrthoSync',
        brand: brand,
        logo: SynapseLogo,
        favIcon: SynapseFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.SYNAPSE),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.SYNAPSE),
        inviteLink: getBrandPortalUrl(brandNamesConstants.SYNAPSE, {includeTrailingSlash: true}),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }

    case brandNamesConstants.CLEARCASTLE:
      return {
        name: 'Clear Castle',
        brand: brand,
        logo: ClearCastle,
        favIcon: ClearCastleFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.CLEARCASTLE),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.CLEARCASTLE),
        inviteLink: getBrandPortalUrl(brandNamesConstants.CLEARCASTLE, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }

    case brandNamesConstants.SMILEXCEL:
      return {
        name: 'Smilexcel',
        brand: brand,
        logo: SmileXcelLogo,
        favIcon: SmileXcelFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.SMILEXCEL),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.SMILEXCEL),
        inviteLink: getBrandPortalUrl(brandNamesConstants.SMILEXCEL, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }
    case brandNamesConstants.AIIQALIGNER:
      return {
        name: 'AIIQ ALIGNER',
        brand: brand,
        logo: AiiqLogo,
        favIcon: AiiqFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.AIIQALIGNER),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.AIIQALIGNER),
        inviteLink: getBrandPortalUrl(brandNamesConstants.AIIQALIGNER, {
          includeTrailingSlash: true,
        }),
        formId: 'd5b11a4b-9205-40d8-81a4-cf32ec435b02',
      }

    case brandNamesConstants.CONFIDENTALIGNER:
      return {
        name: 'CONFIDENT ALIGNER',
        brand: brand,
        logo: ConfidentAlignerLogo,
        favIcon: ConfidentAlignerFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.CONFIDENTALIGNER),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.CONFIDENTALIGNER),
        inviteLink: getBrandPortalUrl(brandNamesConstants.CONFIDENTALIGNER, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }

    case brandNamesConstants.ROUTETOSMILEVSP:
      return {
        name: 'Route to smile',
        brand: brand,
        logo: RouteToSmileLogo,
        favIcon: RouteToSmileFavicon,
        termsAndConditions: getBrandTermsAndConditionsUrl(brandNamesConstants.ROUTETOSMILEVSP),
        privacyPolicy: getBrandPrivacyPolicyUrl(brandNamesConstants.ROUTETOSMILEVSP),
        inviteLink: getBrandPortalUrl(brandNamesConstants.ROUTETOSMILEVSP, {
          includeTrailingSlash: true,
        }),
        formId: '7a5a9377-c60f-45d9-881a-a07780488b88',
      }
    default:
      return defaultBrandConfig
  }
}
